import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Formik, Field, Form } from 'formik';
import * as Yup from "yup";
import { FormikAutoCompleteField } from '../../../shared/Formik/FormikAutoCompleteField';
import { useAuth } from '../../../context/auth';
import { InformationTitle, InformationWrapper } from '../../CampaignDetails.styles';
import { OwnerProps } from './Owner.interface';
import {
    SaveButton,
    FlexWrapper,
    DiscardButton
} from './Owner.styles';

const validationSchema = Yup.object().shape({
    owner: Yup.object().nullable()
});

export function Owner({ user, status, campaignId, refresh }: OwnerProps) {
    const { authToken } = useAuth();
    const [users, setUsers] = useState([]);
    const userEmail = { name: user.email };
    useEffect(() => {
        axios.get(`/wallet/api/payments/wallets/autocomplete/`, {headers: { DTOKEN: `${authToken}`}}).then(res => {
            const data = res.data.results;
            setUsers(data.map((each: string, index: number) => {
                return {
                    id: index,
                    name: each
                }
            }));
        })
    }, [])
    const getDisabled = () => {
        if (status !== 'draft') return { disabled: true };
        return {};
    };
    return (
        <div>
            <InformationTitle>Owner</InformationTitle>
            <InformationWrapper>
                <Formik
                    initialValues={{
                        owner: userEmail
                    }}
                    onSubmit={(values) => {
                        axios.patch(`${process.env.REACT_APP_BASE_URL}/api/campaign/campaign/${campaignId}/owner/`, {email: values.owner.name}, {headers: { DTOKEN: `${authToken}`}}).then(res => {
                            refresh();
                        })
                    }}
                    validationSchema={validationSchema}
                >
                    {({ values }) => (
                        <Form>
                            <Field
                                {...getDisabled()}
                                name='owner'
                                fullWidth
                                variant='outlined'
                                options={users}
                                component={FormikAutoCompleteField}
                                value={values.owner || userEmail}
                            />
                            {values.owner && (userEmail.name !== values.owner.name) && 
                                <FlexWrapper>
                                    <DiscardButton onClick={() => values.owner = userEmail}>Discard</DiscardButton>
                                    <SaveButton type="submit">Save</SaveButton>
                                </FlexWrapper>
                            }
                        </Form>
                    )}
                </Formik>
            </InformationWrapper>
        </div>
    )
}
